/**
 * Honest AI Control readiness. Directory ≠ connected ≠ callable.
 * Callable is only true after a live list-tools returned names.
 * Product ladder: Configured → Connected → Available → Callable → Verified.
 */
export function aiReadinessOf({ models, effective, skillRows, mcpRows, toolPack }) {
  const brain = !!(effective && (effective.label || effective.model || effective.id))
    || (Array.isArray(models) && models.length > 0);
  const playbooks = Array.isArray(skillRows) && skillRows.length > 0;
  const installed = Array.isArray(mcpRows) ? mcpRows.filter((r) => r && (r.mcp_id || r.id || r.name)) : [];
  const connected = installed.length > 0;
  let listedN = 0;
  let listedOk = false;
  Object.values(toolPack || {}).forEach((pack) => {
    if (pack && pack.status === "ready" && Array.isArray(pack.tools) && pack.tools.length) {
      listedOk = true;
      listedN += pack.tools.length;
    }
  });
  const available = listedOk || (brain && playbooks && !connected);
  const callable = listedOk;
  const verified = brain && playbooks && (!connected || listedOk);
  let next = "No Watch brain yet.";
  if (brain && !playbooks) next = "No playbooks on this site.";
  else if (brain && playbooks && !connected) next = "No tool server on this site. Lanes stay optional.";
  else if (brain && playbooks && connected && !listedOk) next = "Installed is not callable until list-tools returns names.";
  else if (verified) next = "Brain, playbooks, and listed tools are on this site.";
  return {
    brain, playbooks, connected, toolListed: listedOk, available, callable, verified, listedN,
    installedN: installed.length,
    next,
    steps: [
      { id: "configured", label: "Configured", on: brain },
      { id: "connected", label: "Connected", on: connected },
      { id: "available", label: "Available", on: available },
      { id: "callable", label: "Callable", on: callable },
      { id: "verified", label: "Verified", on: verified },
    ],
  };
}
